import type { PageData } from 'src/types/types';
import { isTrackingEnabled } from 'src/utils/config';

import getPageTrackingData from './getPageTrackingData';
import setPageTrackingData from './setPageTrackingData';
import { trackLink } from './trackLink';
import { trackView } from './trackView';

export const trackPageLoad = (pageName: string, pageData: PageData) => {
  if (isTrackingEnabled()) {
    trackView(pageName, pageData);
    setPageTrackingData(pageData);
  }
};

export const trackPageInteraction = (
  eventName: string | string[],
  eventData?: Record<string, unknown>,
) => {
  if (isTrackingEnabled()) {
    const currentPageTrackingData = getPageTrackingData();
    const trackingData = {
      ...(eventData || {}),
      ...currentPageTrackingData,
      eventName,
    };
    trackLink(eventName, trackingData);
  }
};
